import { KeyReturnIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Enter = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <KeyReturnIcon size={Sizes[size]} {...rest} color={fill} />;
};

Enter.displayName = 'Enter';
